import type { DashboardTab } from "./dashboardTabs.ts";

export const instantAppId = "38695e7e-368c-49d5-8630-26b271f02d1f";
export const posthogId = "phc_tQ9334EGu96ZEIYzrGPzk1X9VquSqSS6GrAJrXIIAWI";

export const googleAdsConversionTrackingId = "AW-1031308281";
export const googleAdsSignupConversion = "AW-1031308281/9PXNCL3NrPAbEPmH4usD";
export const googleAdsConnectedNumberConversion =
  "AW-1031308281/c8u1CJ3go_EcEPmH4usD";
export const googleAdsSubscribeConversion =
  "AW-1031308281/U29nCIvj6bUYEPmH4usD";
export const googleAdsWebsiteSaleConversion =
  "AW-1031308281/vwB-CIuM4aQYEPmH4usD";

export const monthlyPaymentPerLine = 10;
export const monthlyPaymentPerNumber = 5;
export const pbxmeRecurringUsd = 7;
export const pbxmeSetupFeeUsd = 5;
export const pbxmeNumberPriceUsd = Math.floor(
  (pbxmeRecurringUsd + pbxmeSetupFeeUsd) / 3,
);
export const dailyMessageCap = 500;
export const trialDurationMs = 7 * 24 * 60 * 60 * 1000;
export const supportEmail = "support@supergreen.cc";

export const dashboardUrl = "https://supergreen.cc/app";

// Deep link into a dashboard tab, optionally targeting a specific account
// (matched by phone number for WhatsApp/Telegram, or account id for Facebook).
export const dashboardLink = (tab: DashboardTab, account?: string) =>
  account
    ? `${dashboardUrl}#${tab}/${encodeURIComponent(account)}`
    : `${dashboardUrl}#${tab}`;
